import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { Typography, Box, AccordionSummary, } from "@mui/material";
import SettingsArea from "./SettingsArea";
import UserDataArea from "./UserDataArea";
import AccountInformationArea from "./AccountInformationArea";
import StatisticsArea from "./StatisticsArea";
import { Auth, Amplify } from 'aws-amplify';
import { Link, withRouter, Redirect } from "react-router-dom";




function Dashboard(props) {
  const {
    selectDashboard,
    CardChart,
    statistics,
    toggleAccountActivation,
    pushMessageToSnackbar,
    apiKey,
    setApiKey,
    usage,
    setUsage,
    isAccountActivated,
  } = props;

  useEffect(selectDashboard, [selectDashboard]);
  return (
    <Fragment>

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Your Account
        </Typography>
      </Box>
      <UserDataArea
        pushMessageToSnackbar={pushMessageToSnackbar}
        apiKey={apiKey}
        setApiKey={setApiKey}
        usage={usage}
        setUsage={setUsage}
      />
    </Fragment>
  );
}

Dashboard.propTypes = {
  CardChart: PropTypes.elementType,
  statistics: PropTypes.object.isRequired,
  toggleAccountActivation: PropTypes.func,
  pushMessageToSnackbar: PropTypes.func,
  apiKey:  PropTypes.string,
  setApiKey: PropTypes.func.isRequired,
  usage:  PropTypes.object.isRequired,
  setUsage: PropTypes.func.isRequired,
  isAccountActivated: PropTypes.bool.isRequired,
  selectDashboard: PropTypes.func.isRequired,
};

export default Dashboard;
